import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import CartDrawer from '../components/cart/CartDrawer';
import { siteImages } from '../data/mock';
import { Truck, Shield, Headphones, Award, CheckCircle2, Zap, Dumbbell, Target, ArrowRight, ChevronRight } from 'lucide-react';

const WhyChooseUsPage = () => {
  useEffect(() => {
    document.title = 'Why Choose Sport Fitt Pro | Premium Sports Gear';
  }, []);

  const reasons = [
    { icon: Award, title: 'Premium Quality', desc: 'Every product is vetted against elite performance standards before it ships.' },
    { icon: Truck, title: 'Fast USA Shipping', desc: 'Free delivery on orders over $75. Orders processed within 24 hours.' },
    { icon: Shield, title: 'Secure Checkout', desc: 'Bank-level SSL encryption and PCI-compliant payment processing.' },
    { icon: Headphones, title: 'Expert Support', desc: 'Real athletes on call to help you pick the right gear, every time.' },
    { icon: Zap, title: 'Performance First', desc: 'Gear built for athletes who refuse to settle for anything less than great.' },
    { icon: Target, title: '30-Day Returns', desc: 'Not satisfied? Hassle-free returns within 30 days of delivery.' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <CartDrawer />

      <main className="pt-[104px]">
        {/* Banner */}
        <section className="relative h-80 overflow-hidden bg-ink-950">
          <img src={siteImages.heroSecondary} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink-950 via-ink-950/80 to-transparent" />
          <div className="absolute bottom-0 right-0 w-2/5 h-2 bg-athletic-500" />
          <div className="relative h-full max-w-7xl mx-auto px-4 lg:px-8 flex items-end pb-12">
            <div>
              <nav className="flex items-center gap-2 text-white/60 text-xs font-bold uppercase tracking-wider mb-4">
                <Link to="/" className="hover:text-athletic-400 transition-colors">Home</Link>
                <ChevronRight className="w-3.5 h-3.5" />
                <span className="text-white">Why Choose Us</span>
              </nav>
              <p className="text-athletic-400 text-[11px] font-black tracking-[0.4em] uppercase mb-3">The Difference</p>
              <h1 className="font-display text-5xl md:text-7xl text-white leading-none tracking-wider">
                WHY SPORT <span className="text-athletic-500">FITT PRO</span>
              </h1>
              <p className="text-white/70 mt-4 max-w-lg text-sm">
                Six reasons serious athletes choose us over the rest.
              </p>
            </div>
          </div>
        </section>

        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-20">

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-20">
            {reasons.map((r, i) => (
              <div key={i} className="group bg-ink-50 border-b-4 border-transparent hover:border-athletic-500 hover:bg-ink-900 hover:text-white p-8 transition-all duration-300">
                <div className="flex items-start justify-between mb-5">
                  <div className="w-14 h-14 bg-athletic-500 group-hover:bg-volt-400 flex items-center justify-center transition-colors">
                    <r.icon className="w-6 h-6 text-white group-hover:text-ink-900" strokeWidth={2.2} />
                  </div>
                  <span className="font-display text-4xl text-ink-200 group-hover:text-white/20 leading-none">0{i+1}</span>
                </div>
                <h3 className="font-display text-2xl tracking-wider mb-3">{r.title.toUpperCase()}</h3>
                <p className="text-sm text-ink-500 group-hover:text-white/80 leading-relaxed transition-colors">{r.desc}</p>
              </div>
            ))}
          </div>

          {/* Stats strip */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-0 border-y-4 border-ink-950 mb-20">
            {[
              { n: '100%', l: 'Authentic Products' },
              { n: '8+', l: 'Premium Items' },
              { n: '30d', l: 'Return Window' },
              { n: '24h', l: 'Order Processing' },
            ].map((s, i) => (
              <div key={i} className={`p-8 text-center ${i < 3 ? 'border-r-2 border-ink-100' : ''}`}>
                <p className="font-display text-6xl text-athletic-500 leading-none">{s.n}</p>
                <p className="text-[10px] font-black tracking-[0.3em] uppercase text-ink-600 mt-3">{s.l}</p>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="bg-athletic-500 text-white p-10 lg:p-14 text-center">
            <p className="text-white/80 text-[11px] font-black tracking-[0.4em] uppercase mb-4">Ready To Level Up?</p>
            <h2 className="font-display text-5xl md:text-6xl tracking-wider leading-none mb-6">
              TRAIN WITH THE <span className="text-ink-950">BEST</span>
            </h2>
            <Link to="/shop" className="inline-flex items-center gap-3 px-8 py-4 bg-ink-950 hover:bg-white hover:text-ink-950 text-white font-black uppercase tracking-wider transition-all">
              Shop Now <ArrowRight className="w-5 h-5" />
            </Link>
          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
};

export default WhyChooseUsPage;
